import { processDate } from '../utils/date-utils'

export const MESSAGES = {
    VERSION_MISMATCH: 'Обнаружено несоответствие версий клиента и сервера после обновления. Возможны ошибки при выполнении некоторых операций. Попробуйте перезагрузить страницу позже.',
    REDUCER_ERROR: (action: string): string => `Ошибка при выполнении события: ${action}. Возможны нарушения в работе приложения.`,
    UPDATE_WARNING: (date: string): string => `Запланировано обновление системы.\nЗавершите работу до ${processDate(date)}.`,
}